import "@/App.css";
import "@/firebase";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll, { ScrollToTop } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import Applications from "@/pages/Applications";
import AppDetail from "@/pages/AppDetail";
import Construction from "@/pages/Construction";
import Realisations from "@/pages/Realisations";
import RealizationDetail from "@/pages/RealizationDetail";
import MasterTG from "@/pages/MasterTG";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import AdminForgot from "@/pages/AdminForgot";
import AdminReset from "@/pages/AdminReset";
import TenantSpace from "@/pages/TenantSpace";

function Shell() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");

  if (isAdmin) {
    return (
      <Routes>
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot-password" element={<AdminForgot />} />
        <Route path="/admin/reset-password" element={<AdminReset />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    );
  }

  if (pathname.startsWith("/locataire")) {
    return (
      <Routes>
        <Route path="/locataire" element={<TenantSpace />} />
      </Routes>
    );
  }

  return (
    <SmoothScroll>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/applications" element={<Applications />} />
        <Route path="/applications/construction" element={<Construction />} />
        <Route path="/applications/:slug" element={<AppDetail />} />
        <Route path="/realisations" element={<Realisations />} />
        <Route path="/realisations/:id" element={<RealizationDetail />} />
        <Route path="/master-tg" element={<MasterTG />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/confidentialite" element={<Privacy />} />
        <Route path="/conditions" element={<Terms />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
      <FloatingWhatsApp />
    </SmoothScroll>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Shell />
      <Toaster position="bottom-right" richColors />
    </BrowserRouter>
  );
}

export default App;
